import React, { Component } from 'react';
import WebpackerReact from 'webpacker-react';
import Table from '../components/settings/Rols/Table'

class IndexRol extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: false,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    loadData = () => {
        fetch("/settings/get_rols", {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: true
          });
        });
    }


    render() {
        return (
            <React.Fragment>
                    <Table
                        updateStateLoad={this.updateStateLoad}
                        loadData={this.loadData}
                        data={this.state.data}
                        estados={this.props.estados}
                    />

            </React.Fragment>
        );
    }
}

export default IndexRol;
WebpackerReact.setup({ IndexRol });